const Permission = Object.freeze({
  NOTES: 'notes',
  PRESCRIPTIONS: 'prescriptions',
  RESULT_PROGRESS: 'result progress',
})

export default Permission